// Global site constants: brand, navigation, CTAs, disclosures.
export const BRAND = {
  name: "DuckTheBugs",
  domain: "duckthebugs.com",
  logo: "https://cdn.searchlegends.com/09056a62-59ac-471b-97d8-375e050c6c4d-84jxyx.jpg",
  tagline: "The homeowner's guide to bugs, bites, and backyard pests.",
};

export const NAV = [
  {
    label: "Pests",
    to: "/pests",
    children: [
      { label: "Mosquitoes", to: "/pests/mosquitoes" },
      { label: "Ticks", to: "/pests/ticks" },
      { label: "Wasps & Hornets", to: "/pests/wasps-hornets" },
      { label: "Ants", to: "/pests/ants" },
      { label: "Fleas", to: "/pests/fleas" },
      { label: "Rodents", to: "/pests/rodents" },
    ],
  },
  { label: "DIY", to: "/diy" },
  { label: "Hire a Pro", to: "/hire-a-pro" },
  { label: "Guides", to: "/guides" },
  { label: "About", to: "/about" },
];

export const AFFILIATE_DISCLOSURE =
  "DuckTheBugs may earn a commission from qualifying purchases. Recommendations are based on usefulness and relevance, not commission size.";

export const LEGAL_FOOTER =
  "DuckTheBugs provides educational information and may connect consumers with independent service providers. DuckTheBugs does not currently perform pesticide applications. Information on this site is general educational information — always follow product labels, manufacturer instructions, and applicable laws.";

export const PEST_OPTIONS = [
  "Mosquitoes",
  "Ticks",
  "Wasps/Hornets",
  "Ants",
  "Fleas",
  "Rodents",
  "General Pest",
  "Not Sure",
];

export const PROPERTY_TYPES = [
  "Single-family home",
  "Townhouse",
  "Condo / Apartment",
  "Multi-family / Rental",
  "Commercial property",
];

export const URGENCY_OPTIONS = [
  "As soon as possible",
  "Within a few days",
  "This week",
  "Just planning ahead",
];

export const CONTACT_METHODS = ["Email", "Phone call", "Text message"];
